module.exports = __webpack_public_path__ + "static/media/1-3.b9520e16.svg";